import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { Basket } from '@df/basket/basket.interfaces';
import { Status } from '@df/core/status';
import { AbstractFormComponent } from '@df/ui/form/abstract-form.component';
import { Nexus } from '@tomandco/nexus-api-types';

@Directive()
export abstract class CouponFormComponentDef extends AbstractFormComponent<Basket.ICouponFormData> implements OnInit, OnDestroy {
    removeStatus = new Status();

    /**
     * True if couponForm is on checkout
     * @type {boolean}
     */
    @Input()
    isCheckout?: boolean;

    /**
     * Standard implementation assumes that form can be hidden
     */
    showForm: boolean = false;

    /**
     * Submission endpoing
     */
    protected submitPath = Nexus.Api.Coupon.Add.path;

    override ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(this.app.customer.basket.subscribe(() => this.ref.detectChanges()));
    }

    override ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    /**
     * Coupon getter
     */
    get coupon(): string | string[] | undefined {
        return this.app.customer.basket.data.coupon;
    }

    /**
     * Coupon label getter
     */
    get couponLabel(): string | undefined {
        const coupon = this.coupon;
        return Array.isArray(coupon) ? coupon.join(', ') : coupon;
    }

    /**
     * parent method override to inject checkout flag
     */
    protected override getSubmitAction() {
        return () =>
            this.app.customer.basket.addCoupon(undefined, {
                ...this.data,
                checkout: this.isCheckout
            });
    }

    /**
     * Sends remove coupon request
     * Takes coupon code to remove as param - if not defined we will take this.coupon
     * that should work for one-coupon websited
     *
     * @param  {string} code Coupon code to remove
     * @return {promise}
     */
    remove(code: string | string[] | undefined = this.coupon) {
        if (!this.coupon) {
            return;
        }
        return this.app.customer.basket.removeCoupon(this.removeStatus, {
            coupon: code,
            checkout: this.isCheckout
        });
    }
}
